import { render } from "./repaircompany.vue?vue&type=template&id=5e06d444&ts=true"
import script from "./repaircompany.vue?vue&type=script&lang=ts"
export * from "./repaircompany.vue?vue&type=script&lang=ts"

import "./repaircompany.vue?vue&type=style&index=0&id=5e06d444&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__